import { render } from "./AddEditVideo.vue?vue&type=template&id=81cda8d6&scoped=true"
import script from "./AddEditVideo.vue?vue&type=script&lang=js"
export * from "./AddEditVideo.vue?vue&type=script&lang=js"

import "./AddEditVideo.vue?vue&type=style&index=0&id=81cda8d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81cda8d6"]])

export default __exports__